import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import SummaryApi from '../common'; 
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false); // Add loading state
    const navigate = useNavigate();
    const user = useSelector(state => state?.user?.user);

    const handleOnChange = (e) => {
        if(!user){
            setEmail(e.target.value);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); // Start loading

        try {
            const dataResponse = await fetch(SummaryApi.forgotPassword.url, {
                method: SummaryApi.forgotPassword.method,
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email }), // Send email to backend
            });

            const dataApi = await dataResponse.json();
            setLoading(false); // Stop loading

            if (dataApi.success) {
                toast.success(dataApi.message); // Show success message
                navigate('/OTPCheck', { state: { email } });
            } else if (dataApi.error) {
                toast.error('بريد الكتروني غير مسجل'); // Show error message
            }
        } catch (error) {
            setLoading(false); // Stop loading
            toast.error('حدث خطأ من فضلك حاول مرة اخرى');
        }
    };


    useEffect(() => {
       
        if (user) {
            setEmail(user?.email)
        }

    }, [user]);

    return (
        <section id='forgot-password'>
            <div className='mx-auto container p-4'>
                <div className='bg-white p-5 w-full max-w-sm mx-auto'>
                    <form className='pt-6 flex flex-col gap-2 text-right rtl' onSubmit={handleSubmit}>
                        <div className='grid'>
                            <label>: البريد الالكترونى</label>
                            <div className='bg-slate-100 p-2'>
                                <input
                                    type='email'
                                    placeholder='ادخل البريد الالكترونى'
                                    value={email}
                                    onChange={handleOnChange}
                                    className='w-full h-full outline-none bg-transparent'
                                    required
                                />
                            </div>
                        </div>

                        {/* Submit button for triggering OTP generation */}
                        <div className='flex justify-center'>
                            <button
                                type='submit'
                                disabled={loading} // Disable button during loading
                                className={`flex items-center justify-center px-4 py-2 text-sm rounded-full shadow-md w-[120px] text-center transition-colors duration-300 ${
                                    loading
                                        ? 'bg-gray-500'
                                        : 'bg-blue-900 hover:bg-blue-800 text-white'
                                }`}
                            >
                                {loading ? 'Sending...' : '  OTP ارسال'} {/* Display loading state */}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default ForgotPassword;
